import { SearchGroup } from '@components/input';
import { IFilterSelectItems } from '@redux/slices/order';
import { Col, Modal, Row } from 'antd';
import React, { memo, useContext, useRef } from 'react';

const { confirm } = Modal;
import { ExportButton } from '@styles/components/button';
import { useDispatch, useSelector } from 'react-redux';
import { ModalContext } from 'src/contexts/modal-context';
import { EditModal } from './edit-modal';
import { translate } from '@components/i18n';
import { costSelector, exportCost, fetchCost, importCost } from '@redux/slices/cost';
import { authSelector } from '@redux/slices/auth';
import { DownloadOutlined, ExclamationCircleOutlined, ImportOutlined } from '@ant-design/icons';

export const Header: React.FC = memo(() => {
    const dispatch = useDispatch();
    const modalContext = useContext(ModalContext);
    const authState = useSelector(authSelector);
    const { isExporting, isImporting } = useSelector(costSelector);
    const refInput = useRef<HTMLInputElement>(null);

    const filter = (filter: Partial<IFilterSelectItems>): void => {
        dispatch(
            fetchCost({
                current: 1,
                pageSize: 10,
                query: filter.filterValue,
            }),
        );
    };

    const add = (): void => {
        modalContext.setIsOpen(true, <EditModal />, {
            title: translate('general.registerItem'),
            width: '40%',
        });
    };

    const openInput = (): void => {
        if (!refInput.current) return;
        refInput.current.click();
    };

    const importItems = (files: FileList) => {
        const formData = new FormData();
        formData.append('file', files[0]);

        confirm({
            title: translate('general.importCostConfirmTitle'),
            content: translate('general.importCostConfirmMessage'),
            icon: <ExclamationCircleOutlined />,
            className: 'confirm-modal-styled',
            okText: translate('general.yes'),
            cancelText: translate('general.no'),
            okButtonProps: { type: 'primary', danger: true },
            cancelButtonProps: { type: 'primary', className: 'dark-blue-btn' },
            onOk() {
                dispatch(importCost(formData));
            },
            onCancel() {
                if (refInput.current) {
                    refInput.current.value = '';
                }
            },
        });

        if (refInput.current) {
            refInput.current.value = '';
        }
    };

    const exportItems = (): void => {
        dispatch(exportCost());
    };

    return (
        <Col>
            <Row style={{ marginTop: 20 }} align="middle">
                <Col span={24}>
                    <Row justify={'space-between'} align="middle">
                        <Col span={10}>
                            <SearchGroup
                                allowClear
                                placeholder={translate(
                                    'forms.placeholders.search',
                                )}
                                onSearch={(e) => {
                                    filter({ filterValue: e });
                                }}
                            />
                        </Col>
                        <Col span={14}>
                            <Row justify="end">
                                {authState.isAdmin && (
                                    <>
                                        <input
                                            ref={refInput}
                                            type='file'
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            style={{ display: 'none' }}
                                            onChange={(e) => importItems(e.target.files)}
                                        />
                                        <ExportButton onClick={openInput} loading={isImporting} disabled={isImporting || isExporting}>
                                            {translate('general.import')} <ImportOutlined />
                                        </ExportButton>

                                        <ExportButton onClick={exportItems} loading={isExporting} disabled={isImporting || isExporting}>
                                            {translate('general.export')} <DownloadOutlined />
                                        </ExportButton>
                                    </>
                                )}

                                <ExportButton onClick={add}>
                                    {translate('forms.buttons.addNew')}
                                </ExportButton>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    );
});
